// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore'; // Import Firestore
import { getMessaging, getToken } from 'firebase/messaging';
import { getAuth } from 'firebase/auth';
import HttpService from '../src/hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  ROLE_MAP,
  DATABASE_STATUS_TYPE,
} from '../src/utils/constant';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket:process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
};
const key = process.env.REACT_APP_VAPIDKEY;


// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Export Firestore
export const firestore = getFirestore(app); // Use getFirestore instead
export const auth = getAuth(app);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);

const sendToken = async (token) => {
  if (token) {
    const data = {
      notificationToken: token,
    };
    try {
      const response = await HttpService.post(API_ROUTES.notification, data);
    } catch (error) {
      console.error('Error sending POST request:', error);
    }
  }
};

export const sendPostRequest = async (token) => {
  if (token) {
    const data = {
      notificationToken: token,
    };
    try {
      const response = await HttpService.post(
        API_ROUTES.validateNotification,
        data
      );
      if (!response.data.data.isTokenValid) {
        sendToken(token);
      }
    } catch (error) {
      console.error('Error sending POST request:', error);
    }
  }
};
export const sendDeniedRequest = async () => {
  const token=localStorage.getItem('NotificationToken')
  if (token) {
    const data = {
      notificationToken: token,
      status: DATABASE_STATUS_TYPE.IN_ACTIVE,
    };
    try {
      const response = await HttpService.patch(API_ROUTES.notification, data);
      localStorage.removeItem('NotificationToken');
    } catch (error) {
      console.error('Error sending POST request:', error);
    }
  }else{
    console.log("Token not found in localStorage.")
  }
};
export const gererateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    const token = await getToken(messaging, {
      vapidKey: key,
    });
    localStorage.setItem('NotificationToken', token);
    sendPostRequest(token);
  } else if (permission === 'denied') {
    sendDeniedRequest();
  }
};
